import React from "react";

import { Grid } from "@material-ui/core";
import Button from '@mui/material/Button';
import AddIcon from '@mui/icons-material/Add';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import TextField from '@mui/material/TextField';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import Checkbox from '@mui/material/Checkbox';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import WhatsAppIconBorder from '@mui/icons-material/WhatsApp';
import PhoneIcon from '@mui/icons-material/Phone';
import PhoneIconBorder from '@mui/icons-material/LocalPhoneOutlined';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import InputMask from 'react-input-mask';
import Switch from '@mui/material/Switch';

import AlternateEmailIcon from '@mui/icons-material/AlternateEmail';
import FacebookIcon from '@mui/icons-material/Facebook';
import TwitterIcon from '@mui/icons-material/Twitter';
import InstagramIcon from '@mui/icons-material/Instagram';
import LanguageIcon from '@mui/icons-material/Language';

import Email from "../../../../plas/utils/validators/email";
import alerter from "../../../alerts/alerter"
import Url from "../../../../plas/utils/validators/url";

export default function PhoneNumbers({ place, disable, onChange, options = {} }) {
 
  const theme = createTheme({
    palette: {
      primary: {
        main: '#FFFFFF',
        darker: '#FFFFFF',
      }
    },
  });

  const [webSite, setWebSite] = React.useState(place.webSite ? place.webSite : "");
  const [phoneNumbers, setPhoneNumbers] = React.useState(place.getAllPhoneNumbers());
  const [phoneNumber, setPhoneNumber] = React.useState("");
  const [email, setEmail] = React.useState(place.email ? place.email : "");
  const [delivery, setDelivery] = React.useState(place.delivery);
  const [facebook, setFacebook] = React.useState(place.facebook);
  const [twitter, setTwitter] = React.useState(place.twitter);
  const [instagram, setInstagram] = React.useState(place.instagram);

  const onChangeWebSite = (event) => {
    let trimmed = event.target.value.trim()
    place.webSite = trimmed ? trimmed : null;
    setWebSite(place.webSite);
    onChange();
  }

  const onChangeEmail = (event) => {
    let trimmed = event.target.value.trim()
    place.email = trimmed ? trimmed : null;
    setEmail(event.target.value);
    onChange();
  }

  const onChangeFacebook = (event) => {
    let trimmed = event.target.value.trim()
    place.facebook = trimmed ? trimmed : null;
    setFacebook(event.target.value);
    onChange();
  }

  const onChangeInstagram = (event) => {
    let trimmed = event.target.value.trim()
    place.instagram = trimmed ? trimmed : null;
    setInstagram(event.target.value);
    onChange();
  }

  const onChangeTwitter = (event) => {
    let trimmed = event.target.value.trim()
    place.twitter = trimmed ? trimmed : null;
    setTwitter(event.target.value);
    onChange();
  }

  const addPhoneNumber = () => {
    if (!place.hasPhoneNumber(phoneNumber) && !place.hasWhatsApp(phoneNumber)) {
      place.addPhoneNumber(phoneNumber);
      setPhoneNumbers(place.getAllPhoneNumbers());
      setPhoneNumber("");
    } else {
      alerter.showInfo("El teléfono '" + phoneNumber + "' ya se encuentra en el listado.")
    }
  }

  const changePhoneNumber = (phoneNumber) => {
    if (!place.hasPhoneNumber(phoneNumber)) {
      place.addPhoneNumber(phoneNumber);
    } else {
      place.removePhoneNumber(phoneNumber);
      if (!place.hasWhatsApp(phoneNumber))
        place.addWhatsApp(phoneNumber);
    }

    setPhoneNumbers(place.getAllPhoneNumbers());
  }

  const changeWhatsApp = (phoneNumber) => {
    if (!place.hasWhatsApp(phoneNumber)) {
      place.addWhatsApp(phoneNumber);
    } else {
      place.removeWhatsApp(phoneNumber);
      if (!place.hasPhoneNumber(phoneNumber))
        place.addPhoneNumber(phoneNumber);
    }

    setPhoneNumbers(place.getAllPhoneNumbers());
  }

  const removePhoneNumber = (phoneNumber) => {
    if (place.hasWhatsApp(phoneNumber))
      place.removeWhatsApp(phoneNumber);
    if (place.hasPhoneNumber(phoneNumber))
      place.removePhoneNumber(phoneNumber);

    let phoneNumbers = place.getAllPhoneNumbers();
    setPhoneNumbers(phoneNumbers);

    if (phoneNumbers.length === 0) {
      place.delivery = false
      setDelivery(false)
    }
  }

  const onChangePhoneNumber = (event) => {
    setPhoneNumber(event.target.value.replaceAll(/\s/g, '').replaceAll('_',''));
  }

  const getPhoneMessage = (phoneNumber) => {
    if (!place.hasPhoneNumber(phoneNumber))
      return "Solo WhatsApp";
    else if (!place.hasWhatsApp(phoneNumber))
      return "Solo Llamadas";
    else
      return "Llamadas y WhatsApp"
  }

  const onChangeDelivery = (event) => {
    place.delivery = event.target.checked
    setDelivery(place.delivery)
  }

  return (
      <Grid container spacing={2} >
        <Grid item xs={12}>
           <Grid container spacing={2}>
            <Grid item >
              <AlternateEmailIcon style={{height: '100%'}}/>
            </Grid>
            <Grid item xs={true}>
              <TextField
                variant="outlined" 
                id="email"
                type="email"
                disabled={disable}
                label="Dirección e-mail"
                name="email"
                error={place.email && (!Email.isValid(place.email)) }
                value={email}
                onChange={onChangeEmail}
                fullWidth
                placeholder="emailfalso@gmail.com"/>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <Grid container spacing={2}>
            <Grid item>
              <PhoneIcon style={{height: '100%'}}/>
            </Grid>
            <Grid item xs={true}>
              <InputMask
                  mask="+54 9999999999"
                  onChange={onChangePhoneNumber}
                  value={phoneNumber}
                  disabled={disable}
                  maskChar="_"
                >
                {
                  () =>   
                  <TextField
                    variant="outlined" 
                    id="phoneNumber"
                    label="Número de teléfono"
                    name="phoneNumber"
                    fullWidth
                    placeholder="+54 249 123456 "/>
                }
              </InputMask>
            </Grid>
            <Grid item>
              <ThemeProvider theme={theme}>
                <Button 
                  style={{height: '100%'}}
                  startIcon={<AddIcon/>}
                  disabled={phoneNumber.length !== 13 || disable}
                  variant="contained" 
                  fullWidth
                  onClick={addPhoneNumber}>
                  <b>Agregar</b>
                </Button>
              </ThemeProvider>
            </Grid>
            { phoneNumbers.map((item) => (
              <Grid item xs={12}>
                  <Grid key={item} container spacing={2}>
                    <Grid item xs={12} style={{ textAlign: 'end', marginRight: '24px'}}>
                        <i style={{ marginRight: '16px' }}>
                          ({getPhoneMessage(item)})
                        </i>
                        <Tooltip title="Llamadas"> 
                          <span>
                            <Checkbox 
                              checked={place.hasPhoneNumber(item)}
                              icon={<PhoneIconBorder />} 
                              checkedIcon={<PhoneIcon />}
                              disabled={disable}
                              onChange={() => { changePhoneNumber(item) }}/>
                          </span>
                        </Tooltip>
                        <Tooltip title="WhatsApp">    
                          <span>
                            <Checkbox
                              checked={place.hasWhatsApp(item)}
                              icon={<WhatsAppIconBorder />} 
                              checkedIcon={<WhatsAppIcon />}
                              disabled={disable}
                              onChange={() => { changeWhatsApp(item) }}/>
                          </span>
                        </Tooltip>
                        <b style={{textAlign: 'left', fontSize: '16px', marginLeft: '16px'}}>
                          {item} 
                        </b>
                        <IconButton style={{marginLeft: '16px'}} disabled={disable} onClick={() => removePhoneNumber(item)}>
                          <DeleteOutlineIcon/>
                         </IconButton>
                    </Grid>
                  </Grid>
            </Grid>))}

            { options.delivery !== 'hidden' && phoneNumbers.length > 0 ? (
                <Grid item xs={12} style={{textAlign: 'end'}}>
                  <span>¿Cuenta con servicio de delivery?</span>
                  <Switch checked={delivery} onChange={onChangeDelivery} name="delivery" />
                </Grid>
              ) : (null)
            }
          </Grid>
        </Grid>
        <Grid item xs={12} >
           <Grid container spacing={2}>
            <Grid item >
              <LanguageIcon style={{height: '100%'}}/>
            </Grid>
            <Grid item xs={true}>
              <TextField
                variant="outlined" 
                id="website"
                disabled={disable}
                label="Sitio web del lugar"
                name="website"
                error={place.webSite && (!Url.isValid(place.webSite)) }
                value={webSite}
                onChange={onChangeWebSite}
                fullWidth
                placeholder="https://ejemplo.com.ar"/>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <Grid container spacing={2}>
            <Grid item >
              <FacebookIcon style={{height: '100%'}}/>
            </Grid>
            <Grid item xs={true}>
              <TextField
                variant="outlined" 
                id="facebook"
                disabled={disable}
                label="Facebook"
                name="facebook"
                type="url"
                error={place.facebook && (!Url.isValidHostname(place.facebook,"www.facebook.com")) }
                value={facebook}
                onChange={onChangeFacebook}
                fullWidth
                placeholder="Link al perfil de Facebook"/>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <Grid container spacing={2}>
            <Grid item >
              <TwitterIcon style={{height: '100%'}}/>
            </Grid>
            <Grid item xs={true}>
              <TextField
                variant="outlined" 
                id="twitter"
                disabled={disable}
                type="url"
                label="Twitter"
                name="twitter"
                error={place.twitter && (!Url.isValidHostname(place.twitter,"twitter.com")) }
                value={twitter}
                onChange={onChangeTwitter}
                fullWidth
                placeholder="Link al perfil de Twitter"/>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <Grid container spacing={2}>
            <Grid item >
              <InstagramIcon style={{height: '100%'}}/>
            </Grid>
            <Grid item xs={true}>
              <TextField
                variant="outlined" 
                id="instagram"
                disabled={disable}
                label="Instagram"
                name="instagram"
                error={place.instagram && (!Url.isValidHostname(place.instagram,"www.instagram.com")) }
                value={instagram}
                onChange={onChangeInstagram}
                fullWidth
                placeholder="Link al perfil de Instagram"/>
            </Grid>
          </Grid>
        </Grid>
      </Grid>

  );
}
